import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { ToastProvider } from './components/toast'
import { AuthProvider } from './lib/auth'
import './styles/app.css'

const stored = localStorage.getItem('seyon.admin.theme')
if (stored === 'light' || stored === 'dark') document.documentElement.dataset.theme = stored

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
)
